import { atom } from 'recoil';
export const activitiesModeAtom = atom({
    key: 'activitiesModeAtom',
    default: {
        activityTitle: '...',
        clickedTaskInfoHeader: false,
        returnPath: '/student-dashboard/',
        showBalanceHeader: false,
        showTaskInfoHeader: false
    }
});
